<template>
  <div
    class="absolute top-50 left-2 bg-white pa4 shadow-5 br2"
    style="transform: translateY(-50%)"
  >
    <div
      class="f4 fw6 mb3 mt2"
      :class="{
        'dark-gray': brand === 'lq',
        'purple': brand === 'lh'
      }"
    >
      Local Amenities
    </div>
    <div v-if="this.getFilters">
      <ul class="pa0">
        <li
          class="list pointer pa2 flex items-center f6"
          v-for="(filter,index) in filters"
          :key="index"
          @click="selectFilter(filter.category)"
        >
          <div
            class="ph2 br-pill pointer flex items-center bg-light-gray"
            style="
              width: 3rem;
              padding-top: 0.8rem;
              padding-bottom: 0.8rem;
            "
          >
            <span
              class="animate green b"
              :class="[(getFilters[filter.category] ? 'vis-none' : 'vis-show')]"
            >
              &#10004;
            </span>
            <span
              class="dot animate"
              :class="[(getFilters[filter.category] ? 'bg-silver' : 'move bg-green')]"
            />
          </div>
          <div class="pl3 fw6 pr2">
            {{ filter.title }}
          </div>
        </li>
      </ul>
    </div>
    <div
      class=" f4 fw6 pv2"
      :class="{
        'dark-gray': brand === 'lq',
        'purple': brand === 'lh'
      }"
    >
      Area Radius
    </div>
    <div
      v-if="getMapZoom !== null"
      class="slidecontainer pt3 flex items-center"
    >
      <div
        @click="clickZoomOut"
      >
        <simple-svg
          :filepath="icons.minus"
          stroke="#AAAAAA"
          width="1.25rem"
          height="1.25rem"
          class="mr1 mt2 pointer"
        />
      </div>
      <div class="w-100">
        <input
          v-hammer:pan="setZoomValue"
          v-hammer:tap="setZoomValue"
          type="range"
          :min="getMinMapZoom"
          :max="getMaxMapZoom"
          :value="getMapZoom"
          class="pointer slider"
          ref="myRange"
        >
      </div>
      <div
        @click="clickZoomIn"
        :class="{

        }"
      >
        <simple-svg
          :filepath="icons.plus"
          stroke="#AAAAAA"
          width="1.25rem"
          height="1.25rem"
          class="ml1 mt2 pointer"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    brand () {
      if (this.$store.state.content && this.$route.params.id && this.$store.getters.getDevelopment('developments/' + this.$route.params.id)) {
        const development = this.$store.getters.getDevelopment('developments/' + this.$route.params.id)
        return development.brand
      } else {
        return 'lh'
      }
    },
    getMinMapZoom () {
      return this.$store.state.local.minMapZoom
    },
    getMaxMapZoom () {
      return this.$store.state.local.maxMapZoom
    },
    getFilters () {
      return this.$store.state.local.filters
    },
    getMapZoom () {
      return this.$store.state.local.startMapZoom
    }
  },
  data () {
    return {
      icons: {
        plus: require('@/assets/img/icon-plus-circle.svg'),
        minus: require('@/assets/img/icon-minus-circle.svg')
      },
      filters:
      [
        {
          title: 'Schools',
          category: 'schools'
        },
        {
          title: 'Transport',
          category: 'transport'
        },
        {
          title: 'Leisure',
          category: 'leisure'
        },
        {
          title: 'Green Areas',
          category: 'green_areas'
        },
        {
          title: 'Food & Drinks',
          category: 'food_and_drink'
        }
      ]
    }
  },
  methods: {
    clickZoomIn () {
      this.$emit('clickZoomIn')
    },
    clickZoomOut () {
      this.$emit('clickZoomOut')
    },
    selectFilter (filter) {
      if (this.filters[0].category === filter) {
        this.$store.commit('setSchoolFilter', !this.getFilters[filter])
      } else if (this.filters[1].category === filter) {
        this.$store.commit('setTransportFilter', !this.getFilters[filter])
      } else if (this.filters[2].category === filter) {
        this.$store.commit('setLeisureFilter', !this.getFilters[filter])
      } else if (this.filters[3].category === filter) {
        this.$store.commit('setGreenAreasFilter', !this.getFilters[filter])
      } else if (this.filters[4].category === filter) {
        this.$store.commit('setFoodAndDrinkFilter', !this.getFilters[filter])
      }
      this.$emit('filterSelected', filter)
    },
    setZoomValue () {
      let slider = this.$refs.myRange.value
      this.$store.commit('setMapZoom', slider)
    }
  }
}
</script>
<style>
.vis-show{
  transition: opacity 2s linear;
  transform:translate(0);
  opacity: 1;
}
.vis-none {
  opacity: 0;
}
.animate.move {
  margin-left: 1.3rem; /*.animate width*/
}
.animate {
  transition: all 0.5s ease;
  position: absolute;
}
.dot {
  height: 0.8rem;
  width: 0.8rem;
  background-color: #bbb;
  border-radius: 50%;
}
.slidecontainer {
  width: 100%; /* Width of the outside container */
}

.slider {
    -webkit-appearance: none;
    width: 100%;
    height: 0.3rem;
    border-radius: 5px;
    background: #CCCCCC;
    outline: none;
    opacity: 0.9;
    transition: opacity .2s;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  background: #333333;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  background: #333333;
  cursor: pointer;
}
</style>
